import {create} from "zustand";

type T = {
    showFormDialog: boolean
    currentId?: string,
    openDialog: (id?:string) => void
    closeDialog: () => void
}

export const useSurchargeTimeDefinitionContext = create<T>(set => ({
    showFormDialog: false,
    currentId: undefined,
    openDialog: (id?:string) => {
        if(typeof id === "string"){
            set({showFormDialog: true, currentId: id})
        }else {

            set({showFormDialog: true, currentId: undefined})
        }

    },
    closeDialog: () => set({showFormDialog: false}),
}))

export const useSurchargeTimeDefinitionFormContext = () => {
    const showDialog = useSurchargeTimeDefinitionContext(state => state.showFormDialog)
    const openDialog = useSurchargeTimeDefinitionContext(state => state.openDialog)
    const closeDialog = useSurchargeTimeDefinitionContext(state => state.closeDialog)

    return {showDialog, openDialog, closeDialog}
}